// extracted by mini-css-extract-plugin
export default {"container":"UploadArea_container__GSmYN","description":"UploadArea_description__DmkNO"};